/** @format */

import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";

import asyncComponent from "util/asyncComponent";

/**
 * The app scrolls inside .gx-layout-content (not the window). Without this,
 * the scroll position of the previous page carried over on navigation, so
 * pages like Merchant Detail could open mid-scroll and appear "not scrollable
 * from the top".
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const scroller = document.querySelector(".gx-layout-content");
    if (scroller) scroller.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <ScrollToTop />
    <Switch>
    <Route
        path={`${match.url}p2p-statistics`}
        component={asyncComponent(() => import("./P2PStatistics/index.js"))}
      />
      <Route
        path={`${match.url}P2PMerchant`}
        component={asyncComponent(() => import("./P2PMerchant/index.js"))}
      />
      <Route
        path={`${match.url}P2PMerchantAds`}
        component={asyncComponent(() => import("./P2PMerchantAds/index.js"))}
      />
      <Route
        path={`${match.url}P2PTransactions`}
        component={asyncComponent(() => import("./P2PTransactions/index.js"))}
      />
      <Route
        path={`${match.url}P2PSettings`}
        component={asyncComponent(() => import("./P2POrderLists/index.js"))}
      />
      <Route
        path={`${match.url}support-chat`}
        component={asyncComponent(() => import("./SupportChat/index.js"))}
      />
    </Switch>
  </div>
);

export default App;
